// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  
  /* Button color */
  .btn-pink {
    background-color: #E10174;
    border-color: #E10174;
  }
  
  
  
 
 

/* Fade-in animation */
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/* Apply fadeIn animation */
.animated.fadeIn {
  animation: fadeIn 1s ease-in-out;
}

/* Gradient button styling */
.btn-gradient {
  background: linear-gradient(to right, #E10174, #ff7e5f);
  border: none;
  transition: all 0.3s ease;
}

.btn-gradient:hover {
  background: linear-gradient(to right, #ff7e5f, #E10174);
  transform: scale(1.05);
}

/* Card style enhancements */
.card {
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* Input and button rounded styles */
input, button {
  border-radius: 50px;
}

/* Focus and hover effects */
input:focus, button:focus {
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
  outline: none;
}

/* Alerts (success and error) with fade-in effect */
.alert {
  animation: fadeIn 0.5s ease;
}
/* Add this CSS to fix the header and make the table body scrollable */
.table-responsive {
  position: relative;
}

.table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #E10174;
  color:white;
}

.table tbody {
  max-height: 300px;  /* Adjust the height as needed */
  overflow-y: auto;
}
.dropdown-arrow {
  cursor: pointer;
  display: inline-block;
  font-size: 18px;
  margin-top: 5px;
}

.custom-dropdown {
  position: absolute;
  top: 100%;
  left: 20%;
  transform: translateX(-50%);
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 120px;
}

.dropdown-item {
  padding:3px 12px;
  cursor: pointer;
  color: black;
  font-weight: 600;

  transition: background 0.2s ease;
}

.dropdown-item:hover {
  color: purple;
}
/* Login.css */
.bg-gradient {
  background: linear-gradient(135deg, #f5f7fa, #c3cfe2);
}

.card {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
}

.btn-pink {
  background-color: #E10174;
  border: none;
  transition: background-color 0.3s ease;
}

.btn-pink:hover {
  background-color: #c70066;
}








.bg-blob {
  width: 300px;
  height: 300px;
  background: rgba(225, 1, 116, 0.1);
  border-radius: 50%;
  transform: rotate(45deg);
}

.top-blob {
  top: -10%;
  left: -10%;
}

.bottom-blob {
  bottom: -10%;
  right: -10%;
  width: 400px;
  height: 400px;
  background: rgba(225, 1, 116, 0.05);
}

.login-heading {
  color: #E10174;
  font-weight: bold;
  font-size: 4rem;
  letter-spacing: 2px;
  text-shadow: 2px 2px 4px rgba(225, 1, 116, 0.1);
}

.login-card {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(225, 1, 116, 0.1);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  border-radius: 1rem;
}

.login-input {
  border-color: #E10174;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 50px;
  text-align: center;
  padding-left: 2.5rem;
}

.input-icon {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: #E10174;
  font-size: 1.125rem;
}

.password-toggle {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #E10174;
}

.login-button {
  background-color: #E10174;
  border-color: #E10174;
  padding: 0.75rem;
  box-shadow: 0 10px 20px rgba(225, 1, 116, 0.3);
  border-radius: 50px;
  color: white;
}

.login-button:disabled {
  opacity: 0.7;
}

.login-subheading {
  color: #E10174;
}



/* General Styles */
body {
  font-family: 'Poppins', sans-serif;
  background-color: #f8f9fa;
}

.min-vh-100 {
  min-height: 100vh;
}

.card {
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.card-body {
  padding: 2rem;
}

.form-control,
.form-select {
  border-radius: 8px;
  border: 1px solid #ced4da;
  transition: all 0.3s ease;
}

.form-control:focus,
.form-select:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

.btn-primary {
  background-color: #0d6efd;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background-color: #0b5ed7;
}

.alert {
  border-radius: 8px;
}

.input-group-text {
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.spinner-border {
  width: 1rem;
  height: 1rem;
}

.text-center a {
  color: #0d6efd;
  text-decoration: none;
  font-weight: 600;
}

.text-center a:hover {
  text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/Login.css"],"names":[],"mappings":";;EAEE,iBAAiB;EACjB;IACE,yBAAyB;IACzB,qBAAqB;EACvB;;;;;;;AAOF,sBAAsB;AACtB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,2BAA2B;AAC3B;EACE,gCAAgC;AAClC;;AAEA,4BAA4B;AAC5B;EACE,uDAAuD;EACvD,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,uDAAuD;EACvD,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,sCAAsC;EACtC,aAAa;AACf;;AAEA,mDAAmD;AACnD;EACE,2BAA2B;AAC7B;AACA,sEAAsE;AACtE;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iBAAiB,GAAG,gCAAgC;EACpD,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gBAAgB;;EAEhB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;AACA,cAAc;AACd;EACE,qDAAqD;AACvD;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;;;;;;;;AASA;EACE,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,wCAAwC;EACxC,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,8CAA8C;EAC9C,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;;;AAIA,mBAAmB;AACnB;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B","sourcesContent":["\n  \n  /* Button color */\n  .btn-pink {\n    background-color: #E10174;\n    border-color: #E10174;\n  }\n  \n  \n  \n \n \n\n/* Fade-in animation */\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n/* Apply fadeIn animation */\n.animated.fadeIn {\n  animation: fadeIn 1s ease-in-out;\n}\n\n/* Gradient button styling */\n.btn-gradient {\n  background: linear-gradient(to right, #E10174, #ff7e5f);\n  border: none;\n  transition: all 0.3s ease;\n}\n\n.btn-gradient:hover {\n  background: linear-gradient(to right, #ff7e5f, #E10174);\n  transform: scale(1.05);\n}\n\n/* Card style enhancements */\n.card {\n  background-color: #ffffff;\n  border-radius: 20px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n/* Input and button rounded styles */\ninput, button {\n  border-radius: 50px;\n}\n\n/* Focus and hover effects */\ninput:focus, button:focus {\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);\n  outline: none;\n}\n\n/* Alerts (success and error) with fade-in effect */\n.alert {\n  animation: fadeIn 0.5s ease;\n}\n/* Add this CSS to fix the header and make the table body scrollable */\n.table-responsive {\n  position: relative;\n}\n\n.table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background-color: #E10174;\n  color:white;\n}\n\n.table tbody {\n  max-height: 300px;  /* Adjust the height as needed */\n  overflow-y: auto;\n}\n.dropdown-arrow {\n  cursor: pointer;\n  display: inline-block;\n  font-size: 18px;\n  margin-top: 5px;\n}\n\n.custom-dropdown {\n  position: absolute;\n  top: 100%;\n  left: 20%;\n  transform: translateX(-50%);\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  z-index: 1000;\n  min-width: 120px;\n}\n\n.dropdown-item {\n  padding:3px 12px;\n  cursor: pointer;\n  color: black;\n  font-weight: 600;\n\n  transition: background 0.2s ease;\n}\n\n.dropdown-item:hover {\n  color: purple;\n}\n/* Login.css */\n.bg-gradient {\n  background: linear-gradient(135deg, #f5f7fa, #c3cfe2);\n}\n\n.card {\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(10px);\n}\n\n.btn-pink {\n  background-color: #E10174;\n  border: none;\n  transition: background-color 0.3s ease;\n}\n\n.btn-pink:hover {\n  background-color: #c70066;\n}\n\n\n\n\n\n\n\n\n.bg-blob {\n  width: 300px;\n  height: 300px;\n  background: rgba(225, 1, 116, 0.1);\n  border-radius: 50%;\n  transform: rotate(45deg);\n}\n\n.top-blob {\n  top: -10%;\n  left: -10%;\n}\n\n.bottom-blob {\n  bottom: -10%;\n  right: -10%;\n  width: 400px;\n  height: 400px;\n  background: rgba(225, 1, 116, 0.05);\n}\n\n.login-heading {\n  color: #E10174;\n  font-weight: bold;\n  font-size: 4rem;\n  letter-spacing: 2px;\n  text-shadow: 2px 2px 4px rgba(225, 1, 116, 0.1);\n}\n\n.login-card {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(225, 1, 116, 0.1);\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);\n  border-radius: 1rem;\n}\n\n.login-input {\n  border-color: #E10174;\n  background-color: rgba(255, 255, 255, 0.8);\n  border-radius: 50px;\n  text-align: center;\n  padding-left: 2.5rem;\n}\n\n.input-icon {\n  position: absolute;\n  left: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #E10174;\n  font-size: 1.125rem;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n  color: #E10174;\n}\n\n.login-button {\n  background-color: #E10174;\n  border-color: #E10174;\n  padding: 0.75rem;\n  box-shadow: 0 10px 20px rgba(225, 1, 116, 0.3);\n  border-radius: 50px;\n  color: white;\n}\n\n.login-button:disabled {\n  opacity: 0.7;\n}\n\n.login-subheading {\n  color: #E10174;\n}\n\n\n\n/* General Styles */\nbody {\n  font-family: 'Poppins', sans-serif;\n  background-color: #f8f9fa;\n}\n\n.min-vh-100 {\n  min-height: 100vh;\n}\n\n.card {\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.card-body {\n  padding: 2rem;\n}\n\n.form-control,\n.form-select {\n  border-radius: 8px;\n  border: 1px solid #ced4da;\n  transition: all 0.3s ease;\n}\n\n.form-control:focus,\n.form-select:focus {\n  border-color: #0d6efd;\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n\n.btn-primary {\n  background-color: #0d6efd;\n  border: none;\n  border-radius: 8px;\n  font-weight: 600;\n  transition: all 0.3s ease;\n}\n\n.btn-primary:hover {\n  background-color: #0b5ed7;\n}\n\n.alert {\n  border-radius: 8px;\n}\n\n.input-group-text {\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n}\n\n.spinner-border {\n  width: 1rem;\n  height: 1rem;\n}\n\n.text-center a {\n  color: #0d6efd;\n  text-decoration: none;\n  font-weight: 600;\n}\n\n.text-center a:hover {\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
